<!-- 下拉选择器组件分装 -->
<template>
  <div>
        <div class="containerParent">
          <div class="container">
            <el-row class="search_box">
              <el-col :span="15">
                <el-select size="small" v-model="filters.productTypeName" placeholder="请选择" collapse-tags clearable
              @clear="clearClass" ref="selectClass">
              <el-option :value="filters.productType" :label="filters.productTypeName" style="height: auto">
                <el-tree :data="treeData" node-key="id" ref="tree" highlight-current :props="defaultProps"
                  @node-click="handleClassChange"></el-tree>
              </el-option>
            </el-select>
              </el-col>
              <el-col :span="9">
                <el-button type="primary" size="mini" style="  margin-top:2px;" @click="handleFilter">查询</el-button>
                <span style="width: 10px;">&nbsp;</span>
                <el-button type="primary" size="mini" style="  margin-top:2px;" @click="handleOk">确定选择</el-button>
              </el-col>
            </el-row>
            <el-table ref="selectTable" style="margin-top: 2px;" border stripe :data="grid_data" height="460px"
              highlight-current-row @selection-change="selectGridChange">
              <el-table-column type="selection" width="40">
              </el-table-column>
              <el-table-column prop="proTypeName" label="题目类型" width="80"></el-table-column>
						<el-table-column prop="proNo" label="题号" width="80"></el-table-column>
						<el-table-column prop="proName" label="题目" width="250" show-overflow-tooltip></el-table-column>
						<el-table-column prop="proLevelName" label="难度" width="80"></el-table-column>
						<!-- <el-table-column prop="proScores" label="分值" width="150"></el-table-column> -->
						<el-table-column prop="gradeName" label="年级" width="100" show-overflow-tooltip></el-table-column>
						<el-table-column prop="unitName" label="单元" width="85" show-overflow-tooltip></el-table-column>
						<el-table-column prop="chapterName" label="章节" width="100" show-overflow-tooltip></el-table-column>

            </el-table>
          </div>
        </div>
  </div>
</template>
  
<script>
export default {
  name: "select_exercise",
  props:["options"],
  data() {
    return {
      status: true,
      createTime: new Date(),
      dictKeys: {},
      dbCurrentRow: "",
      productName: "",
      table_height: '',
      dropDownStatus: false,
      keyword: "", //收索条件
      search: {},
      total: 0,
      filters: {
        proType: '',
        kw:'',
				proNo: '',
				proName: '',
				proLevel: '',
				gradeId: '',
				unitId: '',
				lorePointId: '',
        chapterId:'',
				addTime: '',
				addTime2: '',
				schoolId: '',
				status: '',
				rows: 10,
				page: 1,
        productTypeName:'',
        productType:'',
        fromType:2,
      },
      grid_data: [],
      treeData: [],
			defaultProps: {
				children: 'children',
				label: 'groupName'
			},
      sels:[]
    }
  },
  watch: {
    options:{
      async handler(newVal, oldVal) {
				this.grid_data=[]
        
        this.initData()
      }
    }
  },
  methods: {
    		//获取列表
		async getTreeData() {
			let formData = this.$util.jsonToForm({
				id: 0,
				parentId: 0,
				sortNum: 0,
				"isDrag": 0,
        fromType:2
			});
			this.$axios.post("/exercise/getexercisegrouplist", formData).then(res => {
				this.treeData = [{ "id": 0, groupName: "全部", children: res.data.data, groupType: 0 }]
			});
		},
    handleClassChange(data, node) {
			this.filters.productType = data.id;
			this.filters.productTypeName = data.groupName;
      if (data.groupType == 1) {
				this.filters.gradeId = data.id
				this.filters.unitId = ''
				this.filters.lorePointId = ''
				this.filters.chapterId = ''
			}
			else if (data.groupType == 2) {
				this.filters.gradeId = ''
				this.filters.unitId = data.id
				this.filters.lorePointId = ''
				this.filters.chapterId = ''
			}
			else if (data.groupType == 3) {
				this.filters.gradeId = ''
				this.filters.unitId = ''
				this.filters.lorePointId = data.id
				this.filters.chapterId = data.id
			}
			else {
				this.filters.gradeId = ''
				this.filters.unitId = ''
				this.filters.lorePointId = ''
				this.filters.chapterId = ''
			}

			this.$refs.selectClass.blur();
		},
		clearClass() {
			this.filters.productType = '';
			this.filters.productTypeName = "";
      this.filters.gradeId = ''
				this.filters.unitId = ''
				this.filters.lorePointId = ''
		},
    selectGridChange: function (sels) {
      this.sels = sels;
    },
    //切换下拉显示隐藏
    async toggleClick(value) {
      this.dropDownStatus = value
    },
    handleOk() {
      if(this.sels.length==0){
        this.$message("请先选择记录!");
        return;
      }
      this.$emit("callBack", this.sels);
      //this.$refs.selectDown.hide()
    },

    async initData() {
      let formData = this.$util.jsonToForm(this.filters);
      this.$axios.post("/exercise/getexerciseinfolist", formData).then(res => {
        this.total = res.data.total;
        res.data.data.map((item) => {
          item.textkey = item.groupName;
          item.valuekey = item.id;
          this.grid_data.push(item);
        });
      });
    },
    tableListener() {
      let that = this;
      let dom = that.$refs.selectTable.bodyWrapper
      dom.addEventListener("scroll", function () {
        const scrollDistance = dom.scrollHeight - dom.scrollTop - dom.clientHeight;
        if (scrollDistance <= 2) {
          if (that.filters.page < Math.ceil(that.total / that.filters.rows)) {
            that.filters.page++;
            that.initData();
          }
        }
      })
    },
    async handleFilter(e) {
      this.grid_data = []
      this.filters.page = 1;
      await this.initData();
    },
  },
 async created() {
    this.grid_data = [];
    await this.getTreeData()
    this.initData();
  },
  mounted() {
    this.tableListener();
  },
}
</script>
  
<style scoped lang="scss">
//输入框样式
.rotate_right {
  transform: rotate(-180deg);
}

.containerParent {
  // border: solid 1px #84bdec!important;
  padding: 5px;
  overflow: hidden;
  background-color: #fff;

  .container {
    height: 500px;
    overflow: hidden;
    overflow: auto;
  }

  .el-table {
    td {
      padding: 2px 0;

      img {
        width: 24px;
        height: 24px;
        vertical-align: middle;
        cursor: pointer;
      }
    }
  }

  .drop_down_box {

    padding: 0px;
    min-width: 300px;

    .el-button {
      width: unset !important;
    }

    .search_box {
      display: flex;

      .el-button {
        margin: 0;

      }
    }
  }
}

.el-popover,
.el-dropdown-menu {
  border-color: #0000FF !important;
}
</style>
  
  